import { GeneralParameterService } from '../../../../../../../services/generalparameter/generalparameter.service';
import { ComponentType } from '../../../../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../../../../shared/enums/input-type/input-type.module';
import { SelectType } from '../../../../../../../shared/enums/select-type/select-type.module';
import { Component as ComponentModel } from '../../../../../../../models/component.model';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../../../../../../services/shared/utils/utils.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-component-config',
  templateUrl: './component-config.component.html',
  styleUrl: './component-config.component.css'
})
export class ComponentConfigComponent implements OnInit, OnDestroy{
  private destroy$ = new Subject<void>();

  @Input() component!: ComponentModel;
  @Input() haveIndexTitles!: boolean;
  @Output() hoverStart = new EventEmitter<string>();
  @Output() hoverEnd = new EventEmitter<string>();
  ComponentType = ComponentType;
  InputType = InputType;
  SelectType = SelectType;
  defaultColor = "#0A68F1";
  schedule = {
    "weekDay": "Monday",
    "periods": [
        {
            "openingTime": "09:00:00",
            "closingTime": "19:00:00"
        }
    ]
  }
  extensionsString: string = "";
  randomColor: string = "";

  constructor(private generalParameterService: GeneralParameterService, private utils: UtilsService){}

  ngOnInit(){
    if(this.component.type === ComponentType.INPUT && this.component.config?.inputType == InputType.COLOR_PICKER)
    {
      this.randomColor = this.utils.generateRandomHexColor();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  sanitizeHtml(text: string)
  {
    return this.utils.sanitizeHtml(text);
  }

  formatTimeDisplay(time: string): string {
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      return time.slice(0, 5);
    }
    return time;
  }

  hasOnlyOneFileType(): boolean {
    return this.component.config!.fileType != null && this.component.config!.fileType!.length === 1;
  }

  getSingleFileType(): string | null {
    return this.hasOnlyOneFileType() ? this.component.config!.fileType![0] || null : null;
  }

  canAddAnswers(): boolean {
    return this.component.config!.multipleAnswers === true &&
      this.component.type != ComponentType.SELECT &&
      (this.component.multipleConfig!.maxQuantity === undefined || this.component.multipleConfig!.maxQuantity === null || this.component.multipleConfig!.maxQuantity > 1);
  }


  onMouseEnter(componentId: string) {
    this.hoverStart.emit(componentId);
  }

  onMouseLeave(componentId: string) {
    this.hoverEnd.emit(componentId);
  }

  getGridColumns(component: any): number {
    // Desktop
    var optionsLength = component.config?.options?.length || 0;
    var deskColumns = component.columns!;
    var columns = optionsLength < deskColumns ? (optionsLength || 1) : deskColumns;

    // Tablet
    if (this.utils.isTablet() && columns > 2) {
      columns = 2;
    }

    // Mobile
    if (this.utils.isSmartphone() && columns > 1) {
      columns = 1;
    }

    return columns;
  }
}
